"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxFileName = "E:\\720\\720yun_tour_player\\src\\components\\dxc-scroll-menu\\src\\Items.js";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Items = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Items, _React$PureComponent);

  function Items() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      items: []
    });

    _defineProperty(_assertThisInitialized(_this), "itemsRef", {});

    _defineProperty(_assertThisInitialized(_this), "setRef", function (key, index, ref) {
      if (!ref) return;
      var _this$props = _this.props,
          setItemRef = _this$props.setItemRef,
          data = _this$props.data;
      _this.itemsRef["" + key] = {
        index: index,
        key: key,
        ref: ref
      };

      if (Object.keys(_this.itemsRef).length === data.length) {
        setItemRef(_this.itemsRef, _this.modifySource);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "modifySource", 'modifyData');

    _defineProperty(_assertThisInitialized(_this), "init", function (modifySource) {
      _this.itemsRef = {};
      _this.modifySource = modifySource;
    });

    return _this;
  }

  var _proto = Items.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this$props2 = this.props,
        data = _this$props2.data,
        selected = _this$props2.selected;
    var nextData = nextProps.data,
        nextSelected = nextProps.selected;

    if (data !== nextData) {
      this.init('data');
    } else if (nextSelected != selected) {
      this.init('selected');
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        data = _this$props3.data,
        renderItem = _this$props3.renderItem,
        itemData = _this$props3.itemData;
    if (!data || !renderItem) return null;
    return data.map(function (item, i) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          userSelect: 'none'
        },
        ref: function ref(inst) {
          return _this2.setRef(item.id || i, i, inst);
        } // className={`${itemClass} ${Item.props.selected ? itemClassActive : ""}`}
        ,
        key: 'menuItem-' + (item.id || i) // style={itemStyle}
        // tabIndex={disableTabindex ? undefined : 0}
        // role={useButtonRole ? "button" : undefined}
        ,
        __self: _this2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36,
          columnNumber: 9
        }
      }, renderItem(item, i, itemData));
    });
  };

  return Items;
}(_react["default"].PureComponent);

var _default = Items;
exports["default"] = _default;
module.exports = exports.default;